import { Reducer, createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "../state";
import { SERVER_URL } from "../../utils/server";
import { Callback } from "../../index.d";
import { User } from "./authSlice";
import { toggleSessionExpired } from "../utils/uiSlice";
import { pageSizeReq } from "../../utils/constants";

export type Transaction = {
  [index: string]: any;
  description: string;
  valeur?: number;
  moyenOperation: string;
  statutTransaction: string;
  typeSolde?: string;
  typeService?: string | null;
  typeOperation?: string | null;
  emetteur?: string | null;
  destinataire?: string | null;
  numeroTransaction?: string;
};

export declare interface TransactionState {
  [index: string]: any;
}
const initialState: TransactionState = {};

export const transactionSlice = createSlice({
  initialState,
  name: "transaction",
  reducers: {
    createTransaction: (state, action) => {
      state[action.payload.id] = action.payload;
      return state;
    },
    listTransaction: (state, action) => {
      for (const obj of action.payload) {
        state[obj.id] = obj;
      }
      return state;
    },
    removeTransaction: (state, action) => {
      delete state[action.payload];
      return state;
    },
    updateTransaction: (state, action) => {
      state[action.payload.id] = {
        ...state[action.payload.id],
        ...action.payload,
      };
      return state;
    },
  },
});

export const {
  createTransaction,
  listTransaction,
  removeTransaction,
  updateTransaction,
} = transactionSlice.actions;

export const createAsyncTransaction =
  (data: Transaction, callback: Callback, onError: Callback) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      console.log("###DATA::::", data);
      const user = getState().auth.user;
      const result = await fetch(`${SERVER_URL}V2/transaction/creer`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if ([201,200].includes(result.status)) {
        dispatch(listAsyncTransaction());
        callback?.();
      } else if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
      } else {
        onError?.();
      }
    } catch (error) {
      console.log("create transaction error", error);
      onError?.();
    }
  };

export const listAsyncTransaction =
  () => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(
        `${SERVER_URL}transaction/admin-all?size=${pageSizeReq}&page=1`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const res = await result.json();

      if (res.data.length) {
        dispatch(listTransaction(res.data));
      }
    } catch (error) {
      console.log("list transaction error", error);
      // onError?.();
    }
  };

  export const exportAsyncTransaction =
  (periode: string, callback?: Callback) => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(
        `${SERVER_URL}transaction/admin-all/export/${periode}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const resBlob = await result.blob();

      callback?.(resBlob);
     
    } catch (error) {
      console.log("export transaction error", error);
      // onError?.();
    }
  };

export default transactionSlice.reducer as Reducer<TransactionState>;
